<template>
	<div>
		<div class="mytitle">
			<h5>说明:谨慎操作</h5>
		</div>
		<div class="my-btn">
			<label> 关键字：</label>
			<input type="text" v-model="key_word" @keyup.enter="refresh_data" />
			<button class="pre_btn_ok" @click="refresh_data">
				查询
			</button>
		</div>
		<div v-loading="element_loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)" class="my-list">

			<table class="dataintable">
				<tr>
					<th style="display:none;">ID</th>
					<th>序号</th>

					<th class="long">编号</th>
					<th class="long3">详情</th>
					<th class="longlong">描述</th>
					<th class="long">发布时间</th>
					<th>操作</th>
				</tr>
				<tr v-for="(item, index) in list_sys" :key="index">
					<td>{{ item.row_num }}</td>
					<td class="long">{{ item.sys_no }}</td>
					<td class="long3">
						<input style="width: 100%;" type="text" v-model="item.sys_val"
							@keyup.enter="fun_upd(item)" />
					</td>
					<td class="longlong">{{ item.sys_des }}</td>
					<td class="long">{{ item.sys_date }}</td>
					<td class="long">
						<span class="hulue-btn" @click="fun_upd(item)">保存</span>
					</td>
				</tr>

			</table>


		</div>
		<!-- 明细数据提示 -->
		<div id="pre_detail_data" style="display:none;">
			<p v-for="(item, index) in detail_data" :key="index">
				{{ item.name }}={{ item.amount }}
			</p>
		</div>
		<div id="pre_msg_data" style="display:none;"></div>


	</div>
</template>

<script>
	import api from '@/utils/type.js'
	import {
		Method_EasyAdd,
		Method_EasyUpdate,
		Method_DataByPage
	} from '@/utils/loadhttpdata.js';
	import {
		BackSpecial,
		ChangeSpecial
	} from '@/utils/localstore.js';

	export default {
		data() {
			return {
				element_loading: false,

				list_sys: [],

				t_action_name: '',
				t_action: '',
				rowid: '',
				sys_date: '',

				sub_no: '',
				sub_val: '',
				sub_des: '',

				key_word: '',
				detail_data: [],
				sys_data: [],
				sys_data_update: [],
				show_save: false,
				// sys_yd_show:true,
				// menu:[{"id":1,"name":"首页"},{"id":2,"name":"产品展示"},{"id":3,"name":"加入我们"},{"id":4,"name":"代理加盟"},{"id":5,"name":"关于我们"}],
			};
		},
		created: function() {
			this.loaddata();
		},
		methods: {
			loaddata: function() {
				this.t_action_name = '保存';
				this.t_action = 'add';

				this.refresh_data();
			},
			refresh_data: function() {
				this.element_loading=true;
				this.$post(
					api.http_method, Method_DataByPage('data_exp_sys_data', '1', this.key_word, 'sys_set')
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						this.list_sys = res.data.data;
					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});
			},
			fun_upd: function(item) {
				this.fun_clear();
				this.t_action_name = '修改业务信息';
				this.t_action = 'upd';
				// console.log(item);
				this.rowid = item.id;

				this.sub_no = item.sys_no;
				this.sub_val = BackSpecial(BackSpecial(item.sys_val));
				this.sub_des = item.sys_des;

				this.sys_date = item.sys_date;
				// 打开编辑区域
				// this.$refs.file_table.showpop();
				// 展开编辑区域
				// $("#notice").slideDown("slow");
				// 复杂查询一个长数据
				// this.complete_update_flag(item);
				this.fun_save();
			},
			fun_clear: function() {
				//  清理中间变量
				this.t_action_name = '';
				this.t_action = '';
				//  清理固定变量
				this.rowid = 0;
				this.sys_date = '';
				//  清理业务变量
				this.sub_no = '';
				this.sub_val = '';
				this.sub_des = '';

				this.sys_date = '';
			},
			sel_row: function(parm) {
				// 点击表格切换操作
				// console.log(parm);
				this.$refs.file_table.setCurrentRow(parm, 'tr');
			},
			// 鼠标跟踪显示明细内容  这块可以考虑放到table里面
			show_detaildata: function(that, item, type) {

				var x = 0,
					y = 0,
					temp_css = '';
				// console.log('明细数据显示坐标 '+x+' '+y);
				// console.log(item);
				x = that.clientX + 20;
				y = that.clientY;
				temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
					"px;background-color: greenyellow;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 9;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText = temp_css;
				}
				if (type == "1" && item != '') {
					temp_css += "max-width: 200px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";
					document.getElementById("pre_msg_data").innerText = BackSpecial(BackSpecial(item));
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// console.log('不显示明细');
				document.getElementById("pre_detail_data").style.display = 'none';
				document.getElementById("pre_msg_data").style.display = 'none';
			},
			fun_save: function() {
				// console.log('操作：' + this.t_action);
				
				this.element_loading = true;
				
				this.$post(
					api.http_method, Method_EasyUpdate('data_sys_data', this.rowid, this.sub_no, this.sub_val, this
						.sub_des, '',
						this.sys_date)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
				
						this.loaddata();
				
					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});
			}

		}
	};
</script>
<style scoped>
	.mytitle>h2 {
		color: #333333;
	}

	.my-btn {
		display: flex;
		align-items: center;
	}


	.my-list {
		display: flex;
		margin-top: 8px;
	}

	.longlong {
		min-width: 200px !important;
		width: 200px !important;
		max-width: 200px !important;
		overflow: hidden !important;
		text-align: left !important;
	}
	
	.hulue-btn {
		display: inline-block;
		/* border: 1px solid black; */
		border-radius: 5px;
		background: #0000ff;
		text-align: center;
		padding: 2px 2px 2px 2px;
		/* font-size: 16px; */
		margin-left: 2px;
		margin-right: 2px;
		color: #fff;
	}
	
	.hulue-btn:hover {
		cursor: pointer;
		background-color: #00aaff;
		/* font-size: 16px; */
	}
</style>
